import { render, staticRenderFns } from "./DesarrolloElemento.vue?vue&type=template&id=1ca66aae"
import script from "./DesarrolloElemento.vue?vue&type=script&lang=js"
export * from "./DesarrolloElemento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports